export default "__VITE_ASSET__61TP2c9Q__"